import React, { useState, useEffect } from 'react';
import BackIcon from '../../common/Back/BackIcon';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import PageHeading from '../../common/Heading/PageHeading';
import { useForm } from 'react-hook-form';
import { Auth } from 'aws-amplify';
import { DataGrid } from '@mui/x-data-grid';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { ContentTitle, FullDivider, RightGrid } from '../../ui/styled';
import FormInputText from '../../common/Forms/FormTextField';
import FormInputMultiCheckbox from '../../common/Forms/FormCheckbox';
import DropdownFormInput from '../../common/Forms/DropdownForm';
import Typography from '@mui/material/Typography';
import {
  CONTACT_FORM_PUT_AND_POST_URL,
  CONTACT_ORGANIZATION_ADDRESS_URL,
} from '../../../constants';
import { getContactOrganizationAddress } from '../../../redux/contact/contactOrganizationAddress/contactOrganizationAddressSlice';
import ProgressBar from '../../common/ProgressBar/ProgressBar';
import { IconButton } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import { postStopApi, setStopApi } from '../../../services/StopApi/StopApi';
import ReferralSourcesDialog from './ReferralSourcesDialog';
import ProviderLoginDialog from './ProviderLoginDialog';
import Link from '@mui/material/Link';
import {
  getReferralSource,
  resetReferralSource,
  setNewReferralSourceForm,
} from '../../../redux/contact/referralSourcesForm/referralSourcesFormSlice';
import { yupResolver } from '@hookform/resolvers/yup';
import {
  getCancelPopup,
  getFormSuccess,
  getSaveCancel,
} from '../../common/commonUtils/commonUtils';
import { contactValidation } from '../ContactUtils/contactValidation';
import {
  DataGridContainer,
  GridContainer,
  LeftGrid,
  NoteHeading,
} from '../../Episode/Episode.Styled';
import {
  setCntId,
  setCntKey,
  setCntDept,
  setAuthLock,
  setHonorific,
  setPhone,
  setFax,
  setCntOrgId,
  setPlacementCoordinator,
  setCaseManager,
  setParoleAgent,
  setSupervisorChkBox,
  setDataEntry,
  setCntInactiveYn,
  setNetworkUserName,
  setCounty,
  setCntSprCntId,
  setCntEditCntId,
  setCntName,
  setFirstName,
  setMiddleName,
  setLastName,
  setSuffix,
  setTitle,
  setDirectPhone,
  setCntMailAdrPrefix,
  setCntMailAdr,
  setAddress1,
  setAddress2,
  setCity,
  setState,
  setZip,
  setEmail,
  setCreatedDate,
  setEditDate,
  setComment,
  setCntCreateCntId,
  setProbationOfficer,
  setOrganization,
  setContactCreatedby,
  setContactEditedby,
} from '../../../redux/contact/contactForm/contactFormSlice';

import { getContactByUser } from '../services/contactsApi';

const ContactForm = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [formLoading, setFormLoading] = useState(true);
  const [formSuccess, setFormSuccess] = useState(false);
  const [cancelPopUp, setCancelPopUp] = useState(false);
  const [isNewContactForm, setIsNewContactForm] = useState(false);
  const [openReferralSourcesDialog, setOpenReferralSourcesDialog] =
    useState(false);
  const [openProviderLoginDialog, setOpenProviderLoginDialog] =
    useState(false);
  const [openBackdrop, setOpenBackdrop] = useState(false);
  const [referralSources, setReferralSources] = useState({
    isLoading: false,
    data: [],
    total: 0,
    page: 1,
    pageSize: 10,
  });

  const contactForm = useSelector((state) => state.contactForm);
  const contactReferenceData = useSelector(
    (state) => state.contactReferenceData
  );
  //console.log('### contactReferenceData');
  //console.log(contactReferenceData);

  const contactOrganizationAddress = useSelector(
    (state) => state.contactOrganizationAddress
  );

  const { westCareDepartMentList, supervisorList, organizationList, countyList } =
    contactReferenceData;

  const {
    newContactForm,
    cntId,
    cntKey,
    cntDept,
    authLock,
    honorific,
    phone,
    fax,
    cntOrgId,
    placementCoordinator,
    caseManager,
    paroleAgent,
    supervisorChkBox,
    dataEntry,
    cntInactiveYn,
    networkUserName,
    county,
    cntSprCntId,
    cntEditCntId,
    cntName,
    firstName,
    middleName,
    lastName,
    suffix,
    title,
    directPhone,
    cntMailAdrPrefix,
    cntMailAdr,
    address1,
    address2,
    city,
    state,
    zip,
    email,
    createdDate,
    editDate,
    comment,
    cntCreateCntId,
    probationOfficer,
    organization,
    supervisor,
    departMent,
    contactCreatedby,
    contactEditedby,
    referralSourceList,
  } = contactForm;

  const defaultValue = {
    cntId: cntId,
    cntKey: cntKey,
    cntDept: cntDept ? cntDept : '',
    authLock: authLock,
    honorific: honorific,
    phone: phone,
    fax: fax,
    cntOrgId: cntOrgId ? cntOrgId : '',
    placementCoordinator: placementCoordinator,
    caseManager: caseManager,
    paroleAgent: paroleAgent,
    supervisorChkBox: supervisorChkBox,
    dataEntry: dataEntry,
    cntInactiveYn: cntInactiveYn,
    networkUserName: networkUserName,
    county: county,
    cntSprCntId: cntSprCntId ? cntSprCntId : '',
    cntEditCntId: cntEditCntId,
    cntName: cntName,
    firstName: firstName,
    middleName: middleName,
    lastName: lastName,
    suffix: suffix,
    title: title,
    directPhone: directPhone,
    cntMailAdrPrefix: cntMailAdrPrefix,
    cntMailAdr: cntMailAdr,
    address1: address1,
    address2: address2,
    city: city,
    state: state,
    zip: zip,
    email: email,
    createdDate: createdDate,
    editDate: editDate,
    comment: comment,
    cntCreateCntId: cntCreateCntId,
    probationOfficer: probationOfficer,
    organization: organization,
    supervisor: supervisor,
    departMent: departMent,
    contactCreatedby: contactCreatedby,
    contactEditedby: contactEditedby,
    referralSourceList: referralSourceList,
    organizationOrgId: contactOrganizationAddress?.orgId,
    organizationAddress: contactOrganizationAddress?.address,
    organizationCity: contactOrganizationAddress?.city,
    organizationState: contactOrganizationAddress?.state,
    organizationZip: contactOrganizationAddress?.zip,
    organizationPhone: contactOrganizationAddress?.phone,
    organizationFax: contactOrganizationAddress?.fax,
  };

  const useFunction = useForm({
    mode: 'onChange',
    defaultValues: defaultValue,
    resolver: yupResolver(contactValidation),
  });
  const { handleSubmit, reset, control, register, formState } = useFunction;
  const { errors } = formState;

  useEffect(() => {
    getUser().then(function (user) {
      setUser(user);

    })
  }, []);

  const getUser = () => {
    return Auth.currentAuthenticatedUser()
      .then(function (user) {
        getContactByUser(user)
        .then(function (loggedInContact) {
          user.contact = loggedInContact
        })
        .catch(() => console.log('Not signed in'));;
        return user
      })
      .catch(() => console.log('Not signed in'));
  };

  useEffect(() => {
    reset(defaultValue);
  }, [
    defaultValue.cntId,
    defaultValue.cntKey,
    defaultValue.cntDept,
    defaultValue.authLock,
    defaultValue.honorific,
    defaultValue.phone,
    defaultValue.fax,
    defaultValue.cntOrgId,
    defaultValue.placementCoordinator,
    defaultValue.caseManager,
    defaultValue.paroleAgent,
    defaultValue.supervisorChkBox,
    defaultValue.dataEntry,
    defaultValue.cntInactiveYn,
    defaultValue.networkUserName,
    defaultValue.county,
    defaultValue.cntSprCntId,
    defaultValue.cntEditCntId,
    defaultValue.cntName,
    defaultValue.firstName,
    defaultValue.middleName,
    defaultValue.lastName,
    defaultValue.suffix,
    defaultValue.title,
    defaultValue.directPhone,
    defaultValue.cntMailAdrPrefix,
    defaultValue.cntMailAdr,
    defaultValue.address1,
    defaultValue.address2,
    defaultValue.city,
    defaultValue.state,
    defaultValue.zip,
    defaultValue.email,
    defaultValue.createdDate,
    defaultValue.editDate,
    defaultValue.comment,
    defaultValue.cntCreateCntId,
    defaultValue.probationOfficer,
    defaultValue.organization,
    defaultValue.supervisor,
    defaultValue.departMent,
    defaultValue.contactCreatedby,
    defaultValue.contactEditedby,
    defaultValue.referralSourceList,
    defaultValue.organizationOrgId,
    defaultValue.organizationAddress,
    defaultValue.organizationCity,
    defaultValue.organizationState,
    defaultValue.organizationZip,
    defaultValue.organizationPhone,
    defaultValue.organizationFax,
  ]);

  useEffect(() => {
    if (user?.signInUserSession.accessToken.jwtToken) {
      if (cntOrgId) {
        fetchContactOrganizationAddress();
      }
    }
  }, [user?.signInUserSession.accessToken.jwtToken, cntOrgId]);

  const fetchContactOrganizationAddress = async () => {
    const commonParams = `${CONTACT_ORGANIZATION_ADDRESS_URL}/${cntOrgId}`;
    const authorization = `${user?.signInUserSession.accessToken.jwtToken}`;
    dispatch(getContactOrganizationAddress({ commonParams, authorization }));
  };

  useEffect(() => {
    if (!newContactForm) {
      fetchData();
    }
    setTimeout(() => {
      setFormLoading(false);
    }, 500);
  }, [formLoading, referralSourceList]);

  const fetchData = () => {
    setReferralSources((prveState) => ({ ...prveState, isLoading: true }));
    const json = referralSourceList;
    setReferralSources((prveState) => ({
      ...prveState,
      isLoading: false,
      data: json?.map((item, index) => ({
        ...item,
        _id: index,
        orgKey: item.orgKey,
      })),
    }));
  };
  const onSubmit = () => {
    const url = `${CONTACT_FORM_PUT_AND_POST_URL}`;
    const authorization = user?.signInUserSession.accessToken.jwtToken;
    const payload = {
      cntId: newContactForm ? 0 : cntId,
      cntKey: cntKey,
      firstName: firstName,
      middleName: middleName,
      lastName: lastName,
      honorific: honorific,
      suffix: suffix,
      cntDept: cntDept ? cntDept : null,
      cntSprCntId: cntSprCntId ? cntSprCntId : null,
      caseManager: caseManager,
      dataEntry: dataEntry,
      placementCoordinator: placementCoordinator,
      supervisorChkBox: supervisorChkBox,
      paroleAgent: paroleAgent,
      probationOfficer: probationOfficer,
      cntInactiveYn: cntInactiveYn,
      authLock: authLock,
      address1: address1,
      address2: address2,
      city: city,
      state: state,
      zip: zip,
      county: county,
      networkUserName: networkUserName,
      phone: phone,
      fax: fax,
      email: email,
      cntName: cntName,
      cntMailAdrPrefix: cntMailAdrPrefix,
      cntMailAdr: cntMailAdr,
      cntOrgId: cntOrgId ? cntOrgId : null,
      title: title,
      directPhone: directPhone,
      comment: comment,
      cntEditCntId: 17979,
      cntCreateCntId: 13274,
      createdDate: new Date(),
      editDate: new Date(),
    };

    if (newContactForm) {
      postStopApi({ url, payload, authorization }).then((response) => {
        if (response.succeeded === true) {
          setFormSuccess(true);
          setIsNewContactForm(true);
          navigate(-1);
        }
      }).catch((e) => alert(e));
    } else {
      setStopApi({ url, payload, authorization }).then((response) => {
        if (response.succeeded === true) {
          setFormSuccess(true);
          setIsNewContactForm(false);
        }
      }).catch((e) => alert(e));
    }
  };

  const updateReferralSources = (params) => {
    const { row } = params;
    const referralSources = {
      orgContactId: row.orgContactId,
      orgId: row.orgId,
      orgKey: row.orgKey,
    };
    dispatch(getReferralSource(referralSources));
    setOpenBackdrop(true);
    setTimeout(() => {
      setOpenBackdrop(false);
    }, 1000);
    setOpenReferralSourcesDialog(true);
  };

  const handleNewReferralSource = () => {
    dispatch(resetReferralSource());
    dispatch(setNewReferralSourceForm(true));
    setOpenBackdrop(true);
    setTimeout(() => {
      setOpenBackdrop(false);
    }, 1000);
    setOpenReferralSourcesDialog(true);
  };

  const handleCancelPopUp = () => {
    setCancelPopUp(true);
  };

  const columnsData = [
    {
      field: 'actions',
      headerName: 'Actions',
      width: 120,
      type: 'actions',
      renderCell: (params) => {
        return (
          <IconButton onClick={() => updateReferralSources(params)}>
            <EditIcon />
          </IconButton>
        );
      },
    },
    {
      field: 'orgKey',
      headerName: 'Referral Sources',
      sortable: false,
      flex: 1,
    },
  ];

  return (
    <>
      <ContentTitle container>
        <RightGrid item xs={12} sm={6}>
          <BackIcon />
          <PageHeading title='Contact Detail' />
        </RightGrid>
        <LeftGrid item xs={12} sm={6}></LeftGrid>
      </ContentTitle>
      {formLoading ? (
        <ProgressBar />
      ) : (
        <>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={3}>
              <FormInputText
                name='cntKey'
                type='text'
                control={control}
                disabled={true}
                errors={!!errors.cntKey}
                helperText={errors?.cntKey?.message}
                label='Name'
              />
              <FormInputText
                name='honorific'
                type='text'
                control={control}
                errors={!!errors.honorific}
                helperText={errors?.honorific?.message}
                label='Honorific'
                register={register('honorific', {
                  onChange: (e) => dispatch(setHonorific(e.target.value)),
                })}
              />
            </Grid>
            <Grid item xs={12} sm={3}>
              <FormInputText
                name='firstName'
                type='text'
                control={control}
                errors={!!errors.firstName}
                helperText={errors?.firstName?.message}
                label='First Name'
                register={register('firstName', {
                  onChange: (e) => dispatch(setFirstName(e.target.value)),
                })}
              />
              <FormInputText
                name='suffix'
                type='text'
                control={control}
                errors={!!errors.suffix}
                helperText={errors?.suffix?.message}
                label='Suffix'
                register={register('suffix', {
                  onChange: (e) => dispatch(setSuffix(e.target.value)),
                })}
              />
            </Grid>
            <Grid item xs={12} sm={3}>
              <FormInputText
                name='middleName'
                type='text'
                control={control}
                errors={!!errors.middleName}
                helperText={errors?.middleName?.message}
                label='Middle Name'
                register={register('middleName', {
                  onChange: (e) => dispatch(setMiddleName(e.target.value)),
                })}
              />
              <DropdownFormInput
                disabled={user.contact.cntDept !== 4}
                name='cntDept'
                control={control}
                options={westCareDepartMentList}
                defaultId={defaultValue?.cntDept}
                label='WestCare Department'
                register={register('cntDept', {
                  onChange: (e) => dispatch(setCntDept(e.target.value)),
                })}
              />
            </Grid>
            <Grid item xs={12} sm={3}>
              <FormInputText
                name='lastName'
                type='text'
                control={control}
                errors={!!errors.lastName}
                helperText={errors?.lastName?.message}
                label='Last Name'
                register={register('lastName', {
                  onChange: (e) => dispatch(setLastName(e.target.value)),
                })}
              />
              <DropdownFormInput
                name='cntSprCntId'
                control={control}
                options={supervisorList}
                defaultId={defaultValue?.cntSprCntId}
                label='Supervisor'
                register={register('cntSprCntId', {
                  onChange: (e) => dispatch(setCntSprCntId(e.target.value)),
                })}
              />
            </Grid>
          </Grid>
          <Grid container>
            <FormInputMultiCheckbox
              disabled={user.contact.cntDept !== 4}
              name='caseManager'
              label='Case Manager'
              control={control}
              checked={defaultValue?.caseManager}
              register={register('caseManager', {
                onChange: (e) => dispatch(setCaseManager(e.target.value)),
              })}
            />
            <FormInputMultiCheckbox
              disabled={user.contact.cntDept !== 4}
              name='dataEntry'
              label='Data Entry'
              control={control}
              checked={defaultValue?.dataEntry}
              register={register('dataEntry', {
                onChange: (e) => dispatch(setDataEntry(e.target.value)),
              })}
            />
            <FormInputMultiCheckbox
              disabled={user.contact.cntDept !== 4}
              name='placementCoordinator'
              label='Placement Coordinator'
              control={control}
              checked={defaultValue?.placementCoordinator}
              register={register('placementCoordinator', {
                onChange: (e) =>
                  dispatch(setPlacementCoordinator(e.target.value)),
              })}
            />
            <FormInputMultiCheckbox
              disabled={user.contact.cntDept !== 4}
              name='supervisorChkBox'
              label='Supervisor'
              control={control}
              checked={defaultValue?.supervisorChkBox}
              register={register('supervisorChkBox', {
                onChange: (e) => dispatch(setSupervisorChkBox(e.target.value)),
              })}
            />
            <FormInputMultiCheckbox
              disabled={user.contact.cntDept !== 4}
              name='paroleAgent'
              label='Parole Agent'
              control={control}
              checked={defaultValue?.paroleAgent}
              register={register('paroleAgent', {
                onChange: (e) => dispatch(setParoleAgent(e.target.value)),
              })}
            />
            <FormInputMultiCheckbox
              disabled={user.contact.cntDept !== 4}
              name='probationOfficer'
              label='Probation Officer'
              control={control}
              checked={defaultValue?.probationOfficer}
              register={register('probationOfficer', {
                onChange: (e) => dispatch(setProbationOfficer(e.target.value)),
              })}
            />
            <FormInputMultiCheckbox
              disabled={user.contact.cntDept !== 4}
              name='cntInactiveYn'
              label='Inactive'
              control={control}
              checked={defaultValue?.cntInactiveYn}
              register={register('cntInactiveYn', {
                onChange: (e) => dispatch(setCntInactiveYn(e.target.value)),
              })}
            />
            <FormInputMultiCheckbox
              disabled={user.contact.cntDept !== 4}
              name='authLock'
              label='Auth Lock'
              control={control}
              checked={defaultValue?.authLock}
              register={register('authLock', {
                onChange: (e) => dispatch(setAuthLock(e.target.value)),
              })}
            />
          </Grid>
          <Typography variant='h5' style={{ marginBottom: '10px' }}>
            Personal Address :
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={3}>
              <FormInputText
                name='address1'
                type='text'
                control={control}
                errors={!!errors.address1}
                helperText={errors?.address1?.message}
                label='Address 1'
                register={register('address1', {
                  onChange: (e) => dispatch(setAddress1(e.target.value)),
                })}
              />
              <FormInputText
                name='address2'
                type='text'
                control={control}
                errors={!!errors.address2}
                helperText={errors?.address2?.message}
                label='Address 2'
                register={register('address2', {
                  onChange: (e) => dispatch(setAddress2(e.target.value)),
                })}
              />
              <FormInputText
                name='city'
                type='text'
                control={control}
                errors={!!errors.city}
                helperText={errors?.city?.message}
                label='City'
                register={register('city', {
                  onChange: (e) => dispatch(setCity(e.target.value)),
                })}
              />
              <FormInputText
                name='state'
                type='text'
                control={control}
                errors={!!errors.state}
                helperText={errors?.state?.message}
                label='State'
                register={register('state', {
                  onChange: (e) => dispatch(setState(e.target.value)),
                })}
              />
            </Grid>
            <Grid item xs={12} sm={3}>
              <FormInputText
                name='zip'
                type='text'
                control={control}
                errors={!!errors.zip}
                helperText={errors?.zip?.message}
                label='Zip Code'
                register={register('zip', {
                  onChange: (e) => dispatch(setZip(e.target.value)),
                })}
              />
              {/*<FormInputText
                name='county'
                type='text'
                control={control}
                label='County'
                register={register('county', {
                  onChange: (e) => dispatch(setCounty(e.target.value)),
                })}
              />*/}
              <DropdownFormInput
                name='county'
                control={control}
                options={countyList}
                defaultId={defaultValue?.county}
                label='County'
                register={register('county', {
                  onChange: (e) => dispatch(setCounty(e.target.value)),
                })}
              />
              <FormInputText
                name='networkUserName'
                type='text'
                control={control}
                errors={!!errors.networkUserName}
                helperText={errors?.networkUserName?.message}
                label='Net Work User Name'
                register={register('networkUserName', {
                  onChange: (e) => dispatch(setNetworkUserName(e.target.value)),
                })}
              />
            </Grid>
            <Grid item xs={12} sm={3}>
              <FormInputText
                name='phone'
                type='text'
                control={control}
                errors={!!errors.phone}
                helperText={errors?.phone?.message}
                label='Phone'
                register={register('phone', {
                  onChange: (e) => dispatch(setPhone(e.target.value)),
                })}
              />
              <FormInputText
                name='fax'
                type='text'
                control={control}
                errors={!!errors.fax}
                helperText={errors?.fax?.message}
                label='Fax'
                register={register('fax', {
                  onChange: (e) => dispatch(setFax(e.target.value)),
                })}
              />
              <FormInputText
                name='email'
                type='text'
                control={control}
                errors={!!errors.email}
                helperText={errors?.email?.message}
                label='Email'
                register={register('email', {
                  onChange: (e) => dispatch(setEmail(e.target.value)),
                })}
              />
              {/*{email && (
                <Link
                  component='button'
                  variant='body2'
                  onClick={() => setOpenProviderLoginDialog(true)}
                  sx={{ mt: -1 }}
                >
                  View Provider Login Details
                </Link>
              )}*/}
            </Grid>
            <Grid item xs={12} sm={3}>
              <FormInputText
                name='cntName'
                type='text'
                control={control}
                disabled={true}
                errors={!!errors.cntName}
                helperText={errors?.cntName?.message}
                label='Contact Name'
                // register={register('cntName', {
                //   onChange: (e) => dispatch(setCntName(e.target.value)),
                // })}
              />
              <FormInputText
                name='cntMailAdrPrefix'
                type='text'
                control={control}
                errors={!!errors.cntMailAdrPrefix}
                helperText={errors?.cntMailAdrPrefix?.message}
                label='Contact Mail Address Prefix'
                register={register('cntMailAdrPrefix', {
                  onChange: (e) =>
                    dispatch(setCntMailAdrPrefix(e.target.value)),
                })}
              />
              <FormInputText
                name='cntMailAdr'
                type='text'
                control={control}
                errors={!!errors.cntMailAdr}
                helperText={errors?.cntMailAdr?.message}
                label='Contact Mail Address'
                register={register('cntMailAdr', {
                  onChange: (e) => dispatch(setCntMailAdr(e.target.value)),
                })}
              />
            </Grid>
          </Grid>
          <Typography variant='h5' style={{ marginBottom: '10px' }}>
            Organization :
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={3}>
              <DropdownFormInput
                name='cntOrgId'
                control={control}
                options={organizationList}
                defaultId={defaultValue?.cntOrgId}
                errors={!!errors.cntOrgId}
                helperText={errors?.cntOrgId?.message}
                label='Name'
                register={register('cntOrgId', {
                  onChange: (e) => dispatch(setCntOrgId(e.target.value)),
                })}
              />
              <FormInputText
                name='organizationAddress'
                type='text'
                control={control}
                disabled={true}
                label='Address'
              />
            </Grid>
            <Grid item xs={12} sm={3}>
              <FormInputText
                name='organizationCity'
                type='text'
                control={control}
                disabled={true}
                label='City'
              />
              <FormInputText
                name='organizationState'
                type='text'
                control={control}
                disabled={true}
                label='State'
              />
            </Grid>
            <Grid item xs={12} sm={3}>
              <FormInputText
                name='organizationPhone'
                type='text'
                control={control}
                disabled={true}
                label='Phone'
              />
              <FormInputText
                name='organizationZip'
                type='text'
                control={control}
                disabled={true}
                label='Zip Code'
              />
            </Grid>
            <Grid item xs={12} sm={3}>
              <FormInputText
                name='organizationOrgId'
                type='text'
                control={control}
                disabled={true}
                label='Org Id'
              />
              <FormInputText
                name='organizationFax'
                type='text'
                control={control}
                disabled={true}
                label='Fax'
              />
            </Grid>
          </Grid>
          <Typography variant='h5' style={{ marginBottom: '10px' }}>
            Other :
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <FormInputText
                name='title'
                type='text'
                control={control}
                errors={!!errors.title}
                helperText={errors?.title?.message}
                label='Title'
                register={register('title', {
                  onChange: (e) => dispatch(setTitle(e.target.value)),
                })}
              />
              <FormInputText
                name='directPhone'
                type='text'
                control={control}
                errors={!!errors.directPhone}
                helperText={errors?.directPhone?.message}
                label='Direct Phone'
                register={register('directPhone', {
                  onChange: (e) => dispatch(setDirectPhone(e.target.value)),
                })}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormInputText
                name='comment'
                type='text'
                control={control}
                multiline={true}
                rows={3.5}
                errors={!!errors.comment}
                helperText={errors?.comment?.message}
                label='Comment'
                register={register('comment', {
                  onChange: (e) => dispatch(setComment(e.target.value)),
                })}
              />
            </Grid>
          </Grid>
          {getSaveCancel(handleCancelPopUp, null, handleSubmit(onSubmit))}
          {newContactForm ? (
            ''
          ) : (
            <>
              <FullDivider />
              <Grid container>
                <GridContainer container>
                  <Grid item xs={6}>
                    <NoteHeading variant='h5'>
                      To edit Referral Sources please click on particular row
                    </NoteHeading>
                  </Grid>
                  <LeftGrid item xs={6}>
                    <Button
                      variant='contained'
                      onClick={() => handleNewReferralSource()}
                    >
                      New Referral Source
                    </Button>
                  </LeftGrid>
                </GridContainer>
                <Grid item xs={12}>
                  <DataGridContainer>
                    <DataGrid
                      getRowHeight={() => 'auto'}
                      columns={columnsData}
                      rows={referralSources.data}
                      rowCount={referralSources.total}
                      getRowId={(row) => row._id}
                      rowsPerPageOptions={[10, 25, 50]}
                      pageSize={referralSources.pageSize}
                      pagination
                      paginationMode='server'
                      getRowClassName={(params) =>
                        params.indexRelativeToCurrentPage % 2 === 0
                          ? 'even'
                          : 'odd'
                      }
                      loading={referralSources.isLoading}
                      //onRowClick={(param) => cbpAuthRowClick(param.row)}
                      disableColumnFilter
                      disableColumnMenu
                    />
                  </DataGridContainer>
                </Grid>
                <Grid item xs={12}></Grid>
              </Grid>
              <ReferralSourcesDialog
                open={openReferralSourcesDialog}
                setOpen={setOpenReferralSourcesDialog}
                authToken={user?.signInUserSession.accessToken.jwtToken}
                openBackdrop={openBackdrop}
              />
              <ProviderLoginDialog
                open={openProviderLoginDialog}
                setOpen={setOpenProviderLoginDialog}
                email={email}
                cntId={cntId}
                authToken={user?.signInUserSession.accessToken.jwtToken}
              />
            </>
          )}
          {getFormSuccess(formSuccess, setFormSuccess, isNewContactForm)}
          {getCancelPopup(cancelPopUp, setCancelPopUp)}
        </>
      )}
    </>
  );
};

export default ContactForm;
